/** @format */

import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'
import { _$, Form, FormItem, Select, Option } from '@king-design/react'
import { InstanceItem } from 'src/components/SelectInstance'
import { LabelValueItem } from 'src/utils/interface'
import { TriggerRulesProps } from 'src/containers/MonitorCreate/AlarmRule/constants'
import { needDrop } from '../SelectInstanceTabs/constants'
import AllInstanceTab from '../SelectInstanceTabs/All'
// import SelectedInstanceTab from './SelectInstanceTabs/Selected'
import { request } from 'src/utils'
import _ from 'lodash'
import API from 'src/api/ApiCloud'
import RegionBtn from '../../RegionBtn'
import { productObj, podOptions } from './constants'
import { useDeepCompareEffect } from 'react-use'

export interface TacticsAlarmTableHandle {
  getUnbindList?: () => string[]
}

interface TacticsAlarmTableProps {
  className?: string
  policyId: string
  productType: string
  triggerRules: TriggerRulesProps[]
  selectedInstance: InstanceItem[] //选中的实例
  setSelectedInstance: (value: InstanceItem[]) => void
  instanceIdsTotal: number
  setInstaneIdsTotal: (val: number) => void
}

const TacticsAlarmTable = forwardRef<TacticsAlarmTableHandle, TacticsAlarmTableProps>(
  (
    {
      className,
      policyId,
      triggerRules,
      productType,
      selectedInstance,
      setSelectedInstance,
      instanceIdsTotal,
      setInstaneIdsTotal
    },
    ref
  ) => {
    const [region, setRegion] = useState<string>(localStorage.getItem('systemId'))
    const [subList, setSubList] = useState<InstanceItem[]>([])
    const [subValue, setSubValue] = useState<string[]>([])
    const [shardList, setShardList] = useState<InstanceItem[]>([])
    const [shardValue, setShardValue] = useState<string[] | string>([])
    const [workloadList, setWorkloadList] = useState<LabelValueItem[]>([])
    const [workloadValue, setWorkloadValue] = useState<string>('')
    const [runApi, setRunApi] = useState<string>('')
    const [runParams, setRunParams] = useState({})
    const [cdnFilter, setCdnFilter] = useState<boolean>(false)
    const allInstanceTabRef = useRef(null)

    // 多层级默认请求方式
    const defaultRequest = () => {
      setRunApi(API.getInstanceList)
      setRunParams({
        ProductType: productType === '29' ? '45' : productType,
        PolicyId: parseInt(policyId) || policyId,
        RegionKey: region,
        PageIndex: 1,
        PageSize: 10
      })
    }

    // 获取实例，如果有多层级的获取第一级
    useEffect(() => {
      const obj = productObj[productType]
      if (productType !== undefined && region) {
        getInstanceList()
        if (parseInt(productType) === 29) {
          const shardOptions = podOptions.map(item => ({
            label: item,
            value: item
          }))
          setWorkloadList(shardOptions)
          setWorkloadValue(shardOptions[0].value)
        } else {
          setWorkloadList([])
          setWorkloadValue('')
        }
        if (obj?.topType && !subValue) {
          defaultRequest()
        }
      } else {
        setRunApi(undefined)
        setRunParams(undefined)
      }
    }, [region])
    const getInstanceList = async () => {
      const obj = productObj[productType]
      setSubList([])
      setSubValue([])
      setShardList([])
      setShardValue([])
      if (obj?.topType) {
        const result = await request(API.getInstanceList, {
          data: {
            ProductType: obj?.topType,
            RegionKey: region,
            PageIndex: 1,
            PageSize: 9999
          }
        })
        const resourceList = result?.data?.resourceList
        if (resourceList?.length) {
          setSubList(resourceList)
        } else {
          setSubList([])
        }
      } else {
        defaultRequest()
      }
    }

    // 获取二级实例，
    useDeepCompareEffect(() => {
      const obj = productObj[productType]
      if (obj?.topType) {
        if (subValue?.length) {
          getTwoInstance()
        } else {
          defaultRequest()
        }
      }
    }, [subValue])
    const getTwoInstance = async () => {
      const obj = productObj[productType]
      setShardList([])
      setShardValue([])
      const params = {
        ProductType: parseInt(obj.productType),
        ParentInstanceIds: subValue,
        ChildType: obj.shardId || parseInt(productType),
        PolicyId: parseInt(policyId) || policyId,
        PageSize: 9999
      }
      // 容器引擎-POD
      if (obj.topType === 28 && parseInt(productType) === 29) {
        setShardValue('')
        _.set(params, 'Field', 'namespace')
        delete params.ChildType
      }
      if (obj.shardTitle) {
        // 获取2级
        const result = await request(API.getChildInstance, {
          method: 'POST',
          data: params
        })
        const shardList = result?.data?.resourceList
        // 53/29 有二级筛选条件
        if (shardList?.length) {
          setShardList(shardList)
          if (parseInt(productType) === 29) {
            setShardValue(shardList[0]?.instanceId)
          } else {
            setShardValue([shardList[0]?.instanceId])
          }
        } else {
          setRunApi(undefined)
          setRunParams(undefined)
        }
      } else {
        // 其他的直接返回结果作为实例
        params.PageSize = 10
        setRunApi(API.getChildInstance)
        setRunParams(params)
      }
    }

    // 获取shard节点 productType=53\29
    useEffect(() => {
      const obj = productObj[productType]
      if (obj?.shardTitle && obj?.productType) {
        if (shardValue?.length) {
          if (parseInt(productType) === 29) {
            workloadValue && getShardInstance()
          } else {
            getShardInstance()
          }
        }
      }
    }, [shardValue, workloadValue])
    const getShardInstance = async () => {
      const obj = productObj[productType]
      if (obj?.shardTitle && obj?.productType) {
        const params = {
          ProductType: parseInt(obj.productType),
          ChildType: parseInt(productType),
          PolicyId: parseInt(policyId) || policyId
        }
        if (parseInt(productType) === 53) {
          _.set(params, 'ParentInstanceIds', shardValue)
        } else if (parseInt(productType) === 29) {
          // const shardName = shardList?.find(item => item.instanceId === shardValue)
          _.set(params, 'ParentInstanceIds', subValue)
          _.set(params, 'Condition', {
            Namespace: shardValue,
            Workloadtype: workloadValue
          })
          delete params.ChildType
        }
        setRunApi(API.getChildInstance)
        setRunParams(params)
      }
    }

    //  cdn需求：请求命中率和状态码统计的时候，过滤掉非域名项
    useEffect(() => {
      if (parseInt(productType) === 22 && triggerRules?.length) {
        const isFilter = triggerRules.some(item => {
          return item.itemKey === 'cdn.vod.hitpv' || item.itemKey.indexOf('cdn.vod.httpcode.') === 0
        })
        setCdnFilter(isFilter)
        // CDN 过滤已选择实例
        if (isFilter) {
          const filter = selectedInstance.filter(item => {
            return !needDrop.find(name => {
              return name.toLocaleLowerCase() === item.instanceName.toLocaleLowerCase()
            })
          })
          setSelectedInstance(filter)
        }
      }
    }, [triggerRules])

    useImperativeHandle(ref, () => ({
      getUnbindList: () => {
        return allInstanceTabRef?.current?.getUnbindList()
      }
    }))

    return (
      <div className={className}>
        <div className="tabs-all">
          <RegionBtn isUpdate={false} regionChange={value => setRegion(value)} />
          <Form>
            {productObj[productType] ? (
              <>
                <FormItem value={subValue} label={_$(productObj[productType].subTitle)}>
                  <Select
                    container=".select_position"
                    placeholder="默认为全部"
                    width={600}
                    multiple={true}
                    filterable
                    value={subValue}
                    onChangeValue={val => {
                      setSubValue(val)
                    }}
                  >
                    {subList?.length
                      ? subList.map(item => (
                          <Option key={item.instanceId} value={item.instanceId}>
                            {item.instanceName}
                          </Option>
                        ))
                      : null}
                  </Select>
                </FormItem>
                {subValue?.length && productObj[productType].shardTitle ? (
                  <FormItem value={shardValue} label={_$(productObj[productType].shardTitle)}>
                    <Select
                      container=".select_position"
                      width={600}
                      filterable
                      multiple={parseInt(productType) !== 29}
                      value={shardValue}
                      onChangeValue={val => setShardValue(val)}
                    >
                      {shardList?.length
                        ? shardList.map(item => (
                            <Option key={item.instanceId} value={item.instanceId}>
                              {parseInt(productType) === 29 ? item.instanceId : item.instanceName}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </FormItem>
                ) : null}
                {subValue?.length && shardValue && workloadList?.length ? (
                  <FormItem value={workloadValue} label={_$('Workload Type')}>
                    <Select
                      container=".select_position"
                      width={600}
                      filterable
                      value={workloadValue}
                      onChangeValue={val => setWorkloadValue(val)}
                    >
                      {workloadList?.length
                        ? workloadList.map(item => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </FormItem>
                ) : null}
              </>
            ) : null}
          </Form>
          <AllInstanceTab
            ref={allInstanceTabRef}
            productType={productType}
            policyId={policyId}
            cdnFilter={cdnFilter}
            selectedInstance={selectedInstance}
            setSelectedInstance={setSelectedInstance}
            instanceIdsTotal={instanceIdsTotal}
            setInstaneIdsTotal={setInstaneIdsTotal}
            api={runApi}
            params={runParams}
            region={region}
          />
        </div>
      </div>
    )
  }
)

export default styled(TacticsAlarmTable)`
  .tabs-all {
    margin-top: 8px;
  }
  .filter-table {
    margin-top: 8px;
    & > * {
      margin-right: 8px;
    }
  }
  .k-form-item {
    margin: 16px 16px 0 0 !important;
    .k-form-label {
      width: auto;
      margin: 0px;
    }
  }
`
